import React from "react";
import { Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

interface AddressButtonProps {
  title: string;
  onClick?: () => void;
}

const AddressButton: React.FC<AddressButtonProps> = ({ title, onClick }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <StyledButton onClick={onClick}>
        <span>{t(title)}</span>
        <RightOutlined style={{ color: "#CCCCCC" }} />
      </StyledButton>
    </Container>
  );
};

export default AddressButton;

const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  height: "5.2rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0 16px",
  border: `1px solid ${theme.color.light_gray}`,
  borderRadius: "0px",
  marginBottom: "2rem",
  color: theme.color.black,

  "&.ant-btn:hover": {
    borderColor: `${theme.color.light_gray} !important`,
    color: "inherit !important",
  },
}));

const Container = styled.div(() => ({}));
